import { useEffect, useState } from "react";
import OpenLayersMap from "ol/Map";
import View from "ol/View";
import VectorTileLayer from "ol/layer/VectorTile";
import { useGeographic } from "ol/proj";
import { applyStyle } from "ol-mapbox-style";
import { useDfrTheme } from "./dfrTheme";

// Hardcoded map tiles (to avoid interacting with CMP-UI logic)
const tiles = [
    {
        index: 0,
        title: "Street (Light)",
        url: "url(/images/LightStreetViewIcon.png)",
        source: `https://tileserver-onboarding.calanalytics.com/styles/osm-light/style.json`
    },
    {
        index: 1,
        title: "Street (Dark)",
        url: "url(/images/DarkStreetViewIcon.png)",
        source: `https://tileserver-onboarding.calanalytics.com/styles/osm-dark/style.json`
    }
];

// Hardcoded map settings (since we don't have an account to get it from now).
const settings = {
    brightness: 1,
    center: [-82.9988, 39.9612],
    zoom: 12
};

export default function useMap(mapID) {
    const [map, setMap] = useState(null);
    const { mode } = useDfrTheme();

    useGeographic();

    useEffect(() => {
        const map = new OpenLayersMap({
            target: mapID,
            view: new View({
                center: settings.center,
                zoom: settings.zoom
            }),
            controls: []
        });
        map.getViewport().addEventListener("contextmenu", (e) => e.preventDefault());
        setMap(map);
    }, []);

    useEffect(() => {
        if (!map) {
            return;
        }

        // Remove old tile.
        for (const layer of map.getLayers().getArray()) {
            if (layer.get("name") === "base") {
                map.removeLayer(layer);
            }
        }

        const theme = mode === "dark" ? 1 : 0;
        const tile = tiles.find(({ index }) => index === theme);
        const tileLayer = new VectorTileLayer({
            declutter: true,
            opacity: settings.brightness,
            zIndex: 0,
            properties: { name: "base" }
        });

        applyStyle(tileLayer, tile.source);
        map.addLayer(tileLayer);
    }, [map, mode]);

    useEffect(() => {
        if (!map) {
            return;
        }

        return () => {
            // Clean up and dispose of Map.
            map.setTarget(null);
            map.getLayers().forEach((layer) => {
                const source = layer.getSource();
                if (source) {
                    source.dispose?.();
                    source.clear?.(true);
                }
                layer.dispose();
            });
            map.getLayers().clear();
        };
    }, [map]);

    return map;
}
